import { Button } from "primereact/button";
import { useTranslation } from "@i18n/hooks";
import { type PaginationTableProps } from "./pagination-table.type";
import { DataTable } from "../data-table";

export const PaginationTable = <T,>({
	hasNext,
	loadNext,
	emptyMessage,
	...props
}: PaginationTableProps<T>) => {
	const { t } = useTranslation("common");
	return (
		<>
			<DataTable emptyMessage={emptyMessage ?? t("messages.noDataFound")} {...props} />
			<div className="flex justify-content-center align-items-center mt-5">
				<Button className="p-button-primary" disabled={!hasNext} onClick={loadNext}>
					{t("actions.loadMore")}
				</Button>
			</div>
		</>
	);
};
